import { render, staticRenderFns } from "./onglets_infos.vue?vue&type=template&id=3f42945b"
import script from "./onglets_infos.js?vue&type=script&lang=js&external"
export * from "./onglets_infos.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports